import { ActionType, ItemType, UserActionLog } from '../../types/messaging-types';

import { ReduxActionLog } from '../types';
import { OPEN_REPORT_CONTENT_MODAL } from '../../redux-store/report-content/actions';

import ReduxActionNotLoggedError from '../errors/ReduxActionNotLoggedError';
import { channelOnlineStatusesVar } from '../../utils/onlineStatusUtils';
import { getUrlParam } from '../../utils/urlUtils';
import { getBrowserLogger } from '../index';

// Stub action type constants from deleted Redux store slices (legacy code - rearchitecture doesn't use Redux)
const RETRY_SEND_MESSAGE_REQUEST = 'RETRY_SEND_MESSAGE_REQUEST';
const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
const UPDATING_CONVERSATION_LABEL = 'UPDATING_CONVERSATION_LABEL';
const SELECT_CONVERSATION = 'SELECT_CONVERSATION';
const SELECT_FOLDER = 'SELECT_FOLDER';
const LOG_DETAIL_PANE_OPEN = 'LOG_DETAIL_PANE_OPEN';

export const convertReduxActionLog = (log: ReduxActionLog): UserActionLog => {
    const { actionType, actionPayload = {} } = log;
    const channelOnlineStatuses = channelOnlineStatusesVar();
    const isEmployerOnline = channelOnlineStatuses[actionPayload.channelSid] ?? false;
    const from = getUrlParam('from');

    if (!actionPayload) {
        getBrowserLogger().logSignalsDebug(
            'no actionPayload in convertReduxActionLog',
            '',
            actionType
        );
    }

    switch (actionType) {
        case SEND_MESSAGE_SUCCESS:
            if (actionPayload.messageSid.includes('Moderated')) {
                break;
            }
            return {
                itemType: ItemType.MESSAGES,
                itemUid: actionPayload.messageSid,
                action: ActionType.SEND,
                additionalParams: {
                    conversationSid: actionPayload.channelSid,
                    fileCount: actionPayload.fileCount,
                    isEmployerOnline,
                    from,
                },
            };
        case RETRY_SEND_MESSAGE_REQUEST:
            return {
                itemType: ItemType.MESSAGES,
                itemUid: actionPayload.messageSid,
                action: ActionType.SEND,
                additionalParams: {
                    conversationSid: actionPayload.channelSid,
                    isEmployerOnline,
                    from,
                },
            };
        case SELECT_CONVERSATION:
            return {
                itemType: ItemType.CONVERSATIONS,
                itemUid: actionPayload.channelSid,
                action: ActionType.SELECT,
                additionalParams: {},
            };
        case UPDATING_CONVERSATION_LABEL:
            if (
                actionPayload.action !== ActionType.ARCHIVE &&
                actionPayload.action !== ActionType.UNARCHIVE
            ) {
                break;
            }

            return {
                itemType: ItemType.CONVERSATIONS,
                itemUid: actionPayload.channelSid,
                action: actionPayload.action,
                additionalParams: {
                    cause: actionPayload.cause,
                },
            };
        case SELECT_FOLDER:
            return {
                itemType: ItemType.FOLDERS,
                itemUid: actionPayload.destinationFolder.toUpperCase(),
                action: ActionType.SELECT,
                additionalParams: {},
            };
        case OPEN_REPORT_CONTENT_MODAL:
            return {
                itemType: ItemType.CONVERSATIONS,
                itemUid: actionPayload.conversationSid,
                action: ActionType.OPEN_MODERATION_REQUEST,
                additionalParams: {
                    cause: 'conversationMenu',
                },
            };
        case LOG_DETAIL_PANE_OPEN:
            return {
                itemType: ItemType.CONVERSATIONS,
                itemUid: actionPayload.channelSid,
                action: ActionType.OPEN_DETAIL_PANE,

                additionalParams: {
                    cause: actionPayload.cause,
                },
            };
    }

    throw new ReduxActionNotLoggedError(actionType, actionPayload);
};
